<template>
  <div class="container">
    <sys-dialog v-show="dialogVisible" :widthNum="'300'" :sendColor="'#35C0FF'" :show-close="false" :error-msg="errorMsg" @close="closeDialog">
      <img src="../assets/ldp/closebtn.png" class="close-btn" alt="close-btn" v-if="!isSuccess">
      <template v-slot:footer>
        <div class="success-text" v-if="isSuccess">
          {{successText}}
          <div>trong&nbsp;{{countdownNum}}s</div>
        </div>
        <div class="errorBox" v-if="isSuccess">
          Lưu ý: Hội viên cần cập nhật đầy đủ
          <div>thông tin SĐT, EMAIL, BANK chính chủ để</div>
          được nhận code tân thủ
        </div>
      </template>
    </sys-dialog>

    <sys-dialog v-show="renderDialogVisible" :show-close="false" :sendColor="'#35C0FF'" :hasNoMaxWidth="true" :error-msg="errorMsg" @close="closeDialog">
      <img src="../assets/ldp/closebtn.png" class="close-btn" alt="close-btn" v-if="!isSuccess">
      <template v-slot:footer>
        <div class="success-text" v-if="isSuccess">
          {{successText}}
          <div>trong&nbsp;{{countdownNum}}s</div>
        </div>
        <div class="errorBox" v-if="isSuccess">
          Lưu ý: Hội viên cần cập nhật đầy đủ
          <div>thông tin SĐT, EMAIL, BANK chính chủ để</div>
          được nhận code tân thủ
        </div>
      </template>
    </sys-dialog>

    <sys-loading :loading="loading" />

    <div v-if="isMobile" class="mobileRoot">
      <div class="mobileMain">
        <img class="h5-logo" src="../assets/sport7/logo.png" alt="logo">
        <div class="app-middle-slider">
          <sys-swiper class="my-swiper" :swiperOptions="swiperOptions" :pagination="false" :swiper-images="swiperImagesLeft" />
        </div>

        <div class="app-middle-content-6">
          <div :class="['form',{isLogin: !isRegisterAction}]">
            <div class="tags">
              <span :class="isRegisterAction ? 'tag register active' : 'tag register'" @click="() => {switchTab(true);}" />
              <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="() => {switchTab(false);}" />
            </div>

            <div :class="['app-inputs-6', { loginInputs: !isRegisterAction }]">
              <div class="app-form-input">
                <div class="inputArea">
                  <img class="icon" src="../assets/ldp/form/icon-user.png" alt="name" />
                  <input v-model="form.username" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" @blur="() => onBlur('username')" @change="() => onKeyup('username')" @keyup="() => onKeyup('username')" />
                </div>
                <span class="errMsg">{{ formErrMsg.username }}</span>
              </div>

              <div class="app-form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
                <div class="inputArea">
                  <img class="icon" src="../assets/ldp/form/icon-passwd.png" alt="lock" />
                  <input v-model="form.password" :type="showPwd ? 'password' : 'text'" minlength="4" maxlength="15" autocomplete="new-password" placeholder="Mật khẩu" @blur="() => onBlur('password')" />
                  <img :src="require(`../assets/ldp/eye-${showPwd ? 'close':'open'}.png`)" alt @click="showPwd=!showPwd">
                </div>
                <span class="errMsg">{{ formErrMsg.password }}</span>
              </div>

              <div class="app-form-input" v-show="isRegisterAction">
                <div class="inputArea">
                  <img class="icon" src="../assets/ldp/form/icon-passwd.png" alt="check" />
                  <input v-model="form.rePassword" :type="showrePwd ? 'password' : 'text'" placeholder="Nhập lại mật khẩu" minlength="4" maxlength="15" autocomplete="new-password" @blur="() => onBlur('repassword')" />
                  <img :src="require(`../assets/ldp/eye-${showrePwd ? 'close':'open'}.png`)" alt @click="showrePwd=!showrePwd">
                </div>
                <span class="errMsg">{{ formErrMsg.rePassword }}</span>
              </div>

              <div class="app-form-input" v-show="isRegisterAction">
                <div class="inputArea">
                  <img class="icon" src="../assets/sport7/form/icon-phone.png" alt="check" />
                  <input v-model="form.phone" type="text" placeholder="Số điện thoại" maxlength="11" @blur="() => onBlur('phone')" />
                </div>
                <span class="errMsg">{{ formErrMsg.phone }}</span>
              </div>

              <div class="app-form-code-input" v-show="isRegisterAction" style="margin-bottom: 0;">
                <div class="codeArea">
                  <div class="codeInput">
                    <img class="icon" src="../assets/ldp/form/icon-code.png" alt="safe" />
                    <input v-model="form.verificationCode" maxlength="4" oninput="value=value.replace(/[\W]/g, '')" placeholder="Mã xác minh" @blur="() => onBlur('code')" />
                  </div>
                  <span class="code">
                    <img @click="getCode" :src="captchaImg" alt="captcha" />
                  </span>
                </div>

                <span class="errMsg">
                  {{ formErrMsg.code }}
                </span>
              </div>
              <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="isRegisterAction ? handleConfirm : submitAction(2, true)" :vstyle="{ width: '52%',  height: '18%', position: 'absolute', left: '23%', bottom: '-15%'}" :nativeButton="{ width: '100%', height: '47px' }">
              </v-captcha>

            </div>

          </div>
          <div v-if="isRegisterAction" class="submitArea" @click="submitAction(1)">
            <img class="btn" src="../assets/ldp/h5btn.gif" alt="regist" />
          </div>
          <div v-if="!isRegisterAction" class="submitArea login" @click="submitAction(2)">
            <img class="btn" src="../assets/ldp/h5btn.gif" alt="login" />
          </div>
        </div>

      </div>
    </div>

    <div v-else class="content">

      <div :class="[`main`,{login: !isRegisterAction}]">
        <img class="pc-logo" src="../assets/sport7/logo.png" alt="logo">
        <div :class="[`main-right`]">
          <img class="bg-one" src="../assets/ldp/bg1.png" alt="bg1">
          <img class="bg-second" src="../assets/ldp/bg2.png" alt="bg2">
          <img class="bg-third" src="../assets/ldp/bg3.png" alt="bg3">
          <img class="bg-fourth" src="../assets/ldp/bg4.png" alt="bg4">
          <div class="form-container">
            <div :class="isRegisterAction ? 'form' : 'form login'">
              <div class="tags">
                <span :class="isRegisterAction ? 'tag register active' : 'tag register'" @click="() => {switchTab(true);}" />
                <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="() => {switchTab(false);}" />
              </div>

              <div :class="['inputs', { loginInputs: !isRegisterAction }]">
                <div class="form-input">
                  <div class="form-input-item">
                    <img src="../assets/ldp/form/icon-user.png" alt="name" />
                    <input v-model="form.username" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" @blur="() => onBlur('username')" @change="() => onKeyup('username')" @keyup="() => onKeyup('username')" />
                  </div>
                  <span class="errMsg">{{ formErrMsg.username }}</span>
                </div>

                <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
                  <div class="form-input-item">
                    <img src="../assets/ldp/form/icon-passwd.png" alt="name" />
                    <input v-model="form.password" :type="showPwd ? 'password' : 'text'" minlength="4" maxlength="15" autocomplete="new-password" placeholder="Mật khẩu" @blur="() => onBlur('password')" />
                    <img class="showIcon" :src="require(`../assets/ldp/eye-${showPwd ? 'close':'open'}.png`)" alt @click="showPwd=!showPwd">
                  </div>
                  <span class="errMsg">{{ formErrMsg.password }}</span>
                  <!-- <a
                    v-if="!isRegisterAction"
                    class="error"
                    href="https://www.2q.com"
                    >Quên Mật Khẩu?</a
                  > -->
                </div>

                <div class="form-input" v-show="isRegisterAction">
                  <div class="form-input-item">
                    <img src="../assets/ldp/form/icon-passwd.png" alt="name" />

                    <input v-model="form.rePassword" :type="showrePwd ? 'password' : 'text'" placeholder="Nhập lại mật khẩu" minlength="4" maxlength="15" @blur="() => onBlur('repassword')" />
                    <img class="showIcon" :src="require(`../assets/ldp/eye-${showrePwd ? 'close':'open'}.png`)" alt @click="showrePwd=!showrePwd">
                  </div>
                  <span class="errMsg">{{ formErrMsg.rePassword }}</span>
                </div>

                <div class="form-input" v-show="isRegisterAction">
                  <div class="form-input-item">
                    <img src="../assets/sport7/form/icon-phone.png" alt="name" />

                    <input v-model="form.phone" type="text" placeholder="Số điện thoại" maxlength="11" @blur="() => onBlur('phone')" />
                  </div>
                  <span class="errMsg">{{ formErrMsg.phone }}</span>
                </div>

                <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;">
                  <div class="form-input-item">
                    <img src="../assets/ldp/form/icon-code.png" alt="name" />

                    <input v-model="form.verificationCode" oninput="value=value.replace(/[\W]/g, '')" placeholder="Mã xác minh" @blur="() => onBlur('code')" />

                    <span class="code">
                      <img class="codeImg" v-show="captchaImg" :src="captchaImg" @click="getCode" alt="code" />
                    </span>
                  </div>
                  <span class="errMsg">{{ formErrMsg.code }}</span>
                </div>
                <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="isRegisterAction ? handleConfirm : submitAction(2, true)" :vstyle="{ width: '50%', height: '18%', position: 'absolute', left: '25%', bottom: '85px' }" :nativeButton="{  width: '100%', height: '65px' }">

                </v-captcha>

              </div>

            </div>
          </div>
          <div v-if="isRegisterAction" class="submitArea">
            <img class="btn" src="../assets/ldp/regist.gif" @click="submitAction(1)" alt="regist" />
          </div>
          <div v-if="!isRegisterAction" class="submitArea login">
            <img class="btn" src="../assets/ldp/login.gif" @click="submitAction(2)" alt="login" />
          </div>
        </div>
      </div>
      <div class="title" v-if="isRegisterAction">
        <img src="../assets/ldp/end-title.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "../../static/js/initRem";
import { DOMAIN_INVITE_CODE, FORM_VALID_MESSAGE } from "../utils/constant";
import {
  createCustomer,
  getCapCode,
  userLogin,
  userRegister,
  getSystemConfig
} from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
  replacePhonePrefix,
  validForm
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";
import SysSwiperPc from "./common/SysSwiperPc.vue";
const check = {
  //邮箱
  email: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
  // 用户名
  username: /^[0-9a-zA-Z]{4,20}$/,
  // 用户密码
  password: /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/,
  // 手机号
  phone: /^\d{10,11}$/,
};

export default {
  name: "Sport",
  mixins: [captcha],
  components: { SysSwiperPc, swiper, swiperSlide },
  data() {
    return {
      countdownNum: 5,
      timmer: null,
      successText: 'Tự động đăng nhập trang chủ',
      isSuccess: false,
      swiperOptions: {
        loop: true,
        initialSlide: 0,
        coverflowEffect: {
          rotate: 0, //侧转角度（正值凹陷）
          stretch: -20,//每个slide之间拉伸值（正值紧贴）
          depth: 1000,  //值越大为远景（可负值）
          modifier: 1, //depth和rotate和stretch的倍率
          slideShadows: false
        },
        centeredSlides: true,
        slidesPerView: 1.2,//一页显示几个
        spaceBetween: 100,//间隔
        updateOnWindowResize: true,
        watchSlidesProgress: true,//
        effect: 'coverflow', //设置Slide的切换效果，默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）、"cards"(卡片式)、"creative"（创意性）。
        freeMode: 1,
        autoplay: {//自动轮播//
          delay: 3000, //
          disableOnInteraction: false,//操作swiper后 自动轮播不会停止//
        },
      },
      showPwd: true,
      showrePwd: true,
      renderDialogVisible: false,
      dialogLoginVisible: false,
      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,

      dialogBgi: require("../assets/sport7/bgi-dialog.png"),

      form: {
        by: 1,
        username: "",
        password: "",
        rePassword: "",
        code: "",
        phone: "",
        link: "",
        domain: "",
        inviteCode: null,
        verificationCode: "",
      },
      formErrMsg: {
        username: null,
        phone: "",
        password: null,
        rePassword: null,
        code: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      closeImage: require("../assets/sport5/close-dialog.png"),

      swiperImagesLeft: [
        require("../assets/ldp/game-1.png"),
        require("../assets/ldp/game-2.png"),
        require("../assets/ldp/game-3.png"),
        require("../assets/ldp/game-4.png"),
        require("../assets/ldp/game-5.png")
      ],
      swiperImagesRight: [
        require("../assets/ldp/game-3.png"),
        require("../assets/ldp/game-4.png"),
        require("../assets/ldp/game-5.png"),
        require("../assets/ldp/game-1.png"),
        require("../assets/ldp/game-2.png"),
      ],
      captchaImg: "",
      swiperLeftData: null,
      swiperRightData: null,
      loginVerify: false,
    };
  },
  created() {
    this.swiperLeftData = {
      autoplay: false,
    }
    getSystemConfig().then(res => {
      if (res.data.code == 0) {
         const config = res.data.data.find(item => item.configKey === "login_verify_flag");
         if (config) {
          this.loginVerify = config.configValue === "1" ? true : false;
         }
      }
    })
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getCode();


    this.inii();
  },
  methods: {
    getCode() {
      this.form.verificationCode = ''
      getCapCode()
        .then(res => {
          if (!res.body.code) {
            this.captchaImg = res.body.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onKeyup(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g, "");
      }
    },
    switchTab(flag) {
      this.errMsg = {
        username: null,
        password: null,
        phone: null,
        email: null
      };
      this.isRegisterAction = flag;
    },
    onBlur(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g, "");
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
        } else {
          this.formErrMsg.username = null;
        }
      }

      if (key === "password") {
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
        } else if (this.form.rePassword.length < 6) {
          this.formErrMsg.rePassword = "Mật khẩu không trùng khớp";
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
        } else {
          this.formErrMsg.password = null;
        }
      }

      if (key === "repassword") {
        if (!this.form.rePassword) {
          this.formErrMsg.rePassword = "* Vui lòng nhập lại mật khẩu";
        } else if (this.form.rePassword.length < 6) {
          this.formErrMsg.rePassword = "Mật khẩu không trùng khớp";
        } else if (!check.password.test(this.form.rePassword)) {
          this.formErrMsg.rePassword = "*Số điện thoại không đúng định dạng";
        } else if (this.form.rePassword !== this.form.password) {
          this.formErrMsg.rePassword = "*Mật khẩu không trùng khớp";
        } else {
          this.formErrMsg.rePassword = null;
        }
      }

      if (key === "phone") {
        const reg = /^\d{10,11}$/;
        if (!this.form.phone) {
          this.formErrMsg.phone = "*Vui lòng nhập số điện thoại";
        } else if (!reg.test(this.form.phone)) {
          this.formErrMsg.phone = "*Số điện thoại không đúng định dạng";
        } else {
          this.formErrMsg.phone = null;
        }
      }

      if (key === "code") {
        if (!this.form.verificationCode) {
          this.formErrMsg.code = "* Vui lòng nhập mã xác minh";
        } else {
          this.formErrMsg.code = null;
        }
      }
    },
    closeDialogLogin() {
      this.dialogLoginVisible = false;
    },
    showDialogLogin() {
      this.dialogLoginVisible = true;
    },
    submitAction(type, isAuto = false) {
      let errorMsg = validForm(type, this.form);

      if (type === 1) {
        //  注册校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
        // 重复密码
        if (!this.form.rePassword) {
          this.formErrMsg.rePassword = "*Vui lòng nhập số điện thoại";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.rePassword = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        } else if (this.form.password !== this.form.rePassword) {
          this.formErrMsg.rePassword = "*Mật khẩu không trùng khớp";
          return;
        }
        // 电话
        if (!this.form.phone) {
          this.formErrMsg.phone = "*Vui lòng nhập số điện thoại";
          return;
        } else if (!check.phone.test(this.form.phone)) {
          this.formErrMsg.phone = "*Số điện thoại không đúng định dạng";
          return;
        }
        // 验证码
        if (!this.form.verificationCode) {
          this.formErrMsg.code = "*Vui lòng nhập mã xác minh";
          return;
        } else {
          this.formErrMsg.code = null;
        }
      } else if (type === 2) {
        // 登陆校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "*Tên đăng nhập phải từ 4 -20 ký tự";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
      }

      this.loading = true;
      // 登陆
      if (type === 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          password: md5(temp.password)
        };
        this.login(params, isAuto);
      } else {
        this.form.inviteCode = this.inviteCodeObj[location.host] || DOMAIN_INVITE_CODE[location.host] || "";
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        console.log('m诶错都值。。。')
        this.register();
      }
    },
    login(params, isAuto) {
      if (!isAuto && this.loginVerify) {
        this.showCheck = true;
        this.handleCheck(() => {});
        return;
      }
      userLogin(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.isSuccess = true;
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password,
                res.data.data.token
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.params = Object.assign({}, this.form);
      // let params = (this.params = Object.assign({}, this.form));
      // if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
      //   this.setDialogMsg(
      //     FORM_VALID_MESSAGE.registerFailTitle,
      //     FORM_VALID_MESSAGE.passwordMsg
      //   );
      //   this.loading = false;
      //   return;
      // }
      // this.handleCheck();
      this.handleCheck(this.handleConfirm);
    },
    inii() {
      // this.dialogLoginVisible = false;
      // this.renderDialogVisible = true;
      // this.dialogImg = this.dialogBgiRegister;
    },
    handleConfirm(params = Object.assign({}, this.form)) {
      // params.phone = params.phone.length === 10 ? params.phone : replacePhonePrefix(params.phone);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.isSuccess = true;
            this.errorMsg.title = 'ĐĂNG KÝ THÀNH CÔNG'
            this.errorMsg.content = ''
            this.timmer = setInterval(() => {
              this.countdownNum--;
              if (this.countdownNum == 0) {
                clearInterval(this.timmer);
              }
            }, 1000)
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password,
                res.data.data.token
              );
            }, 5000);
          } else {
            this.isSuccess = false;
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
          this.getCode();
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
          this.getCode();
          this.$refs.vcaptcha1.handleReset()
          this.form.verificationCode = ""
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>
<style >
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  height: 100%;
}
</style>
<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.mobileRoot {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

// 电脑端
.content {
  background-image: url("../assets/ldp/bg.png");
  background-size: 100% 100%;
  height: 100%;
  background-repeat: no-repeat;

  .pc-logo {
    width: 0.854701rem;
    margin-bottom: 0.25641rem;
  }

  .main {
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    //&.login {
    //  margin-top: 1.656rem;
    //}

    .main-left {
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      padding-left: 172px;
      flex: 2;
      .logo {
        position: absolute;
        left: 30px;
        z-index: 10;
      }
      .main-left-slider {
        margin-top: 20px;
        width: 540px;
        height: 680px;
        overflow: hidden;
        img {
          width: 544px;
        }
      }
      .bottom-banner {
        display: flex;
        height: 225px;
        img {
          height: 225px;
        }
      }
    }
    .main-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .bg-one {
        width: 2.032479rem;
        position: absolute;
        top: -0.878632rem;
        right: 3.87094rem;
      }
      .bg-second {
        width: 1.832479rem;
        position: absolute;
        top: -0.3547rem;
        right: 2.076068rem;
      }
      .bg-third {
        width: 1.832479rem;
        position: absolute;
        top: -0.3547rem;
        left: 2.076068rem;
      }
      .bg-fourth {
        width: 2.032479rem;
        position: absolute;
        top: -0.878632rem;
        left: 3.87094rem;
      }
      .flex {
        display: flex;
      }
      .absolute {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      .left {
        //left: 0.094rem;
        left: 100%;
      }
      .right {
        right: 103%; //0.094rem;
      }
      .grid {
        width: 3.16rem;
        //display: grid;
        //grid-template-columns: repeat(2, 1fr);
        //column-gap: 0.12rem;
        > img {
          width: 1.516rem;
        }
      }
    }
    .w-full {
      width: 100%;
    }
    /deep/ .my-swiper-pc {
      width: 100%;
      .swiper-slide {
        img {
          width: 1.516rem !important;
          margin: 0 0.06rem;
        }
      }
    }
    .social-app {
      position: absolute;
      left: 24px;
      top: 20px;
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        cursor: pointer;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 135px;
      }
    }

    .middle-content {
      width: 100%;
      height: 500px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .middle-content-left {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .middle-content-center {
        flex: 3;
        display: flex;
        align-items: center;
        flex-direction: column;
        .giai-tri {
          height: 332px;
        }
        .dang-ky-nhan {
          width: 325px;
          height: 75px;
          margin-top: 20px;
        }
      }
      .middle-content-right {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .title {
    margin: 0 auto;
    text-align: center;
    img {
      width: 1.910256rem;
      position: relative;
      top: -0.35rem;
    }
  }
}
.container {
  height: 100%;
  .success-text {
    color: #000;
    font-size: 0.076923rem;
    font-weight: 500;
    line-height: 0.094017rem;
    text-align: center;
    margin-bottom: 0.08547rem;
  }
  .close-btn {
    width: 0.128205rem;
    height: 0.128205rem;
    position: absolute;
    top: 0.052735rem;
    right: 0.062735rem;
  }
  /deep/ .mask-layer .modal .modal-content {
    width: 2.055556rem;
    height: auto;
    padding: 0.128205rem 0;
    border: 0.021368rem solid transparent;
    border-radius: 0.128205rem;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(to right, #fff, #fff),
      linear-gradient(180deg, #5de1ff 0%, #3075f2 100%),
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(157, 48, 242, 0.5) 100%
      );
    &.m {
      width: 450px;
      height: auto;
      padding: 20px 0;
      position: relative;
      .close-btn {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 10px;
        right: 20px;
      }
      .modal-title {
        font-size: 30px;
      }
      .modal-text {
        margin: 0;
        font-size: 24px;
        text-align: center;
      }
      .success-text {
        font-size: 24px;
        line-height: 30px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .errorBox {
        font-family: Montserrat;
        font-size: 20px;
        font-style: italic;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        color: #d40000;
      }
    }
  }

  /deep/ .errorBox {
    font-family: Montserrat;
    font-size: 0.076923rem;
    font-style: italic;
    font-weight: 500;
    line-height: 0.086923rem;
    text-align: center;
    color: #d40000;
  }
}
// 手机端
.mobileRoot {
  height: auto;
  min-height: 100vh;
  background: url("../assets/ldp/bg-h5.png") no-repeat center top / 100%;
  background-size: 100% 100%;
  .mobileMain {
    display: flex;
    flex-flow: column;
    align-items: center;
    position: relative;

    .h5-logo {
      width: 1.5rem;
      margin-top: 0.1rem;
      margin-bottom: 0.48rem;
    }

    .title {
      margin-top: 2.287rem;
      width: calc(100% - 60px);
      height: 0.773rem;
    }

    .app-middle-slider {
      width: 7.5rem;
      height: 5.36rem;
      margin-bottom: 0.48rem;
      position: relative;
      .btn-prev {
        position: absolute;
        left: -50px;
        top: 50%;
        transform: translate(-100%, -50%);

        img {
          width: 0.32rem;
          height: 0.613rem;
        }
      }
      .btn-next {
        position: absolute;
        right: -50px;
        top: 50%;
        transform: translate(100%, -50%);
        img {
          width: 0.32rem;
          height: 0.613rem;
        }
      }

      /deep/ .my-swiper {
        img {
          width: 70%;
          margin: 0 auto;
          display: block;
        }
        .nav-btn {
          width: 0.32rem;
          height: 0.613rem;
          background-image: url("../assets/sport7/btn-prev.svg");
        }
        .prev-btn {
          left: -1.067rem;
        }
        .next-btn {
          right: -1.067rem;
          background-image: url("../assets/sport7/btn-next.svg");
        }
      }
      img {
        width: 4.427rem;
        height: 5.28rem;
      }
    }
    .app-middle-content-6 {
      display: flex;
      flex-direction: column;
      align-items: center;
      .form {
        width: 6rem;
        box-sizing: border-box;
        background: linear-gradient(180deg, #5de1ff 0%, #3075f2 100%);
        // background-image: url("../assets/sport7/form/form-bg.png");
        background-size: 100% 100%;
        border-radius: 0.3rem;
        &.isLogin {
          height: 3.48rem;
          background-color: #fff;
          // background-image: url("../assets/sport7/form/form-bg-1.png");
        }
        .tags {
          width: 100%;
          position: relative;
          // top: -0.35rem;
          display: flex;
          align-items: center;
          justify-content: center;

          .tag {
            width: 2.98rem;
            height: 0.8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: url("../assets/ldp/form/login-1.png");
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;

            &.register {
              background-image: url("../assets/ldp/form/register-1.png");
            }

            &.active {
              height: 0.8rem;
              background-image: url("../assets/ldp/form/login-2.png");
              &.register {
                background-image: url("../assets/ldp/form/register-2.png");
              }
            }
          }
        }

        .app-inputs-6 {
          position: relative;
          // top: -0.3rem;
          padding-top: 0.633rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 0.43rem;
          .bottom-tips {
            font-size: 0.18rem;
            line-height: 0.4rem;
            font-weight: 400;
            color: #fff;
            //display: none;
          }
        }
        .loginInputs {
          top: 0;
        }

        .app-form-input {
          width: 5.2rem;
          height: 0.5rem;
          border-radius: 80px;
          background: #fff no-repeat;
          background-size: 100% 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          .inputArea {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 0.1rem;
            img {
              width: 0.267rem;
              height: 0.267rem;
              margin: 0 0.07rem 0 0.2rem;
            }
            input {
              flex: 1;
              height: 100%;
              border: none;
              outline: none;
              font-size: 0.24rem;
              color: #000;
              background-color: transparent;
              &::placeholder {
                color: #8b8787;
                opacity: 0.9;
                font-size: 0.2rem;
                // 这里让浏览器自动去判断
                line-height: normal;
              }
            }
          }
          .errMsg {
            position: absolute;
            // top: 0.7rem;
            bottom: 0;
            transform: translateY(105%);
            color: #fff;
            font-size: 0.18rem;
            line-height: 0.3rem;
            font-weight: 400;

            &.longErrMsg {
              left: 50%;
              width: 100%;
              transform: translateX(-50%);
            }
          }
        }
        .app-form-code-input {
          width: 4.96rem;
          height: 0.533rem;
          position: relative;
          display: flex;
          flex-direction: column;
          .codeArea {
            display: flex;
            align-items: center;
            height: 100%;
            .codeInput {
              height: 100%;
              width: 3.5rem;
              display: flex;
              border-radius: 80px;
              align-items: center;
              background: #fff no-repeat;
              background-size: 100% 100%;
              img {
                width: 0.267rem;
                height: 0.267rem;
                margin: 0 0.07rem 0 0.2rem;
              }
              input {
                flex: 1;
                height: 100%;
                border: none;
                outline: none;
                font-size: 0.24rem;
                color: #000;
                background-color: transparent;
                &::placeholder {
                  color: #8b8787;
                  opacity: 0.9;
                  font-size: 0.2rem;
                  // 这里让浏览器自动去判断
                  line-height: normal;
                }
              }
            }
            .code {
              width: 1.5rem;
              height: 0.55rem;
              position: relative;
              img {
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 0.1rem;
                margin-left: 0.1rem;
              }
            }
          }
          .errMsg {
            position: absolute;
            top: 0.7rem;
            background: linear-gradient(135.48deg, #990000 0%, #f90707 89.26%);
            -webkit-background-clip: text;
            color: transparent;
            font-size: 0.18rem;
            line-height: 0.3rem;
            font-weight: 400;

            &.longErrMsg {
              left: 50%;
              width: 100%;
              transform: translateX(-50%);
            }
          }
        }

        .login {
          margin-top: 0.3rem;
        }

        a.error {
          position: absolute;
          top: 0.7rem;
          right: 0;
          color: #000;
          font-size: 0.18rem;
          line-height: 0.4rem;
          font-weight: 400;
          text-decoration: underline;
          text-align: center;
        }
        .submitBtn {
          margin-top: 0.2rem;
          width: 1.8rem;
          cursor: pointer;
          &.reg {
            height: 0.55rem;
          }

          &.login {
            margin: 0.2rem auto;
            height: 0.55rem;
            bottom: 0.42rem;
          }
        }
      }
    }
    .submitArea {
      width: 3.54rem;
      margin-top: 0.2rem;
      text-align: center;
      .btn {
        cursor: pointer;
        width: 100%;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 93px;
      }
    }
  }
}

/deep/ .close-img {
  //width: 40px;
  //height: 40px;
  //opacity: 0;
  top: -0.15rem !important;
  right: -0.15rem !important;
}

@media only screen and (max-width: 767px) {
  /deep/ .moda {
    padding: 20vw !important;
  }

  /deep/ .close-img {
    width: 0.5rem !important;
    height: 0.5rem !important;
    top: -10px !important;
    right: -15px !important;
  }
}

// 注册弹窗
@font-face {
  font-family: "UTMMabella";
  src: url("../assets/font/UTM-Mabella.ttf");
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}

.dialog-tip {
  font-size: 18px;
  margin-top: 12px;
  color: #fffcfc;
  font-family: "Montserrat";
  font-weight: 100;
}

.app-form-container {
  position: relative;
  text-align: center;
  margin-top: 0.3rem;
}

.form-container {
  position: relative;
  .form {
    width: 2.051282rem;
    background: linear-gradient(180deg, #5de1ff 0%, #3075f2 100%);
    // background-image: url("../assets/sport7/form-pc/form-bg.png");
    border-radius: 0.128205rem;
    background-size: 100% 100%;
    &.login {
      height: 1.128205rem;
      // background-image: url("../assets/sport7/form-pc/form-bg-1.png");
      .tags {
        top: 0;
      }
    }

    .tags {
      width: 100%;
      height: auto;
      position: relative;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        width: 1.017094rem;
        height: 0.299145rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/ldp/form/login-1.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        &.register {
          background-image: url("../assets/ldp/form/register-1.png");
        }

        &.active {
          height: 0.299145rem;
          background-image: url("../assets/ldp/form/login-2.png");
          &.register {
            background-image: url("../assets/ldp/form/register-2.png");
          }
        }
      }
    }

    .inputs {
      height: 100%;
      position: relative;
      padding-top: 0.08547rem;
      .bottom-tips {
        font-size: 18px;
        line-height: 40px;
        font-weight: 400;
        color: #000000;
        //display: none;
      }
    }
    .loginInputs {
      top: 0;
    }

    .form-input {
      width: 1.709402rem;
      height: auto;
      position: relative;
      margin: 0 auto;
      .showIcon {
        position: absolute;
        right: 0.08547rem;
        left: auto;
        top: 50%;
        width: 0.111111rem;
        transform: translateY(-50%);
      }
      .errMsg {
        color: #fff;
        font-size: 0.094rem;
        line-height: 0.156rem;
        height: 0.156rem;
        font-weight: 500;
        display: block;

        &.longErrMsg {
          left: 50%;
          width: 100%;
          transform: translateX(-50%);
        }
      }
      .form-input-item {
        position: relative;
        width: 1.709402rem;
        > img:first-child {
          width: 0.104rem;
          height: 0.104rem;
          position: absolute;
          // top: calc(50% - .104rem);
          top: 50%;
          transform: translateY(-50%);
          left: 0.104rem;
        }
        .code {
          height: 100%;
          width: 0.521rem;
          position: absolute;
          right: 0.052rem;
          top: 0;
          .codeImg {
            cursor: pointer;
            width: 100%;
            height: 100%;
            border-radius: 0.042rem;
          }
        }
      }

      input {
        width: 1.709402rem;
        height: 0.17094rem;
        border-radius: 0.417rem;
        background: #fff;
        background-size: 100% 100%;
        border: none;
        outline: none;
        font-size: 0.094rem;
        text-indent: 0.281rem;
        color: #000;
        &::placeholder {
          color: #5a5a5a;
          opacity: 0.45;
          font-size: 0.094rem;
          // 这里让浏览器自动去判断
          // line-height: 0.245rem;
        }
      }
    }

    a.error {
      color: #000;
      font-size: 18px;
      line-height: 40px;
      font-weight: 400;
      text-decoration: underline;
      text-align: center;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .submitBtn {
      margin-top: 20px;
      width: 180px;
      cursor: pointer;
      &.reg {
        height: 55px;
      }

      &.login {
        margin: 20px auto;
        height: 55px;
        bottom: 42px;
      }
    }
  }
}
.submitArea {
  text-align: center;
  width: 1.299145rem;
  margin-top: 0.08547rem;
  .btn {
    cursor: pointer;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ldp.vue